import type { DeliveryType } from 'shared/src/api/goodsService/getGoodsOptions';
import { TodayDeliveryOptionBadge } from './TodayDeliveryOptionBadge';
import { StandardOptionBadge } from './StandardOptionBadge';
import { ThirdPLDeliveryOptionBadge } from './ThirdPLDeliveryOptionBadge';

export const OptionBadge = ({
  deliveryType,
  isSoldOut,
  orderDeadline,
}: {
  deliveryType: DeliveryType;
  isSoldOut: boolean;
  orderDeadline: string | null;
}) => {
  const isTodayDelivery = deliveryType === 'today' || deliveryType === 'shak';
  const isThirdPLDelivery = deliveryType === 'third_pl';

  if (isThirdPLDelivery) {
    return (
      <ThirdPLDeliveryOptionBadge
        isSoldOut={isSoldOut}
        orderDeadline={orderDeadline}
      />
    );
  }

  if (isTodayDelivery) {
    return (
      <TodayDeliveryOptionBadge
        isSoldOut={isSoldOut}
        orderDeadline={orderDeadline}
      />
    );
  }

  return <StandardOptionBadge />;
};
